module.exports = __webpack_public_path__ + "img/icn_entrevistapaga_40.1dbda6a2.svg";